/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import Command from "../Commands/Command";
import { useAppCoffeeMugContext } from "../Components/AppCoffeeMugContext";
import { translationKeys, useTranslation } from "../Internationalisierung/i18nBasis";

export type ExecuteOptions = {
    message?: string;
    noSnackbar: boolean;
};

export default function useExecute<TData, TInput>(command: Command<TData, TInput>) {
    const { t } = useTranslation();
    const coffeeMug = useAppCoffeeMugContext();

    function execute(input: TInput, options: ExecuteOptions = { noSnackbar: false }): Promise<TData | undefined> {
        coffeeMug.show(options.message ?? t(translationKeys.useExecute.meldung));
        return command.execute(input, options.noSnackbar).finally(coffeeMug.hide);
    }

    return execute;
}